import SelectPermissionsDialog from "./select-permissions-dialog.jsx";

export default SelectPermissionsDialog;